// src/modules/app-views/crm/pages/Boards/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DatabaseOutlined, ImportOutlined, UserAddOutlined } from '@ant-design/icons';
import showMigrationDocumentModal from 'components/core/migration/MigrationDocumentModal';
import showMigrationModal from 'components/core/migration/MigrationSettingsModal';
import { dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';
import showQuickCaptureModal from '../modals/QuickCaptureModal';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const crmInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      {
        key: 'quickCapture',
        label: 'quick_capture',
        icon: <UserAddOutlined />,
        onClick: () => {
          showQuickCaptureModal();
        },
      },
      'divider',
      {
        key: 'importCrmDocument',
        label: 'migrate_document',
        icon: <ImportOutlined />,
        hidden: ({ storedSubscription }) => {
          const tokens = storedSubscription?.migrationTokens || [];
          const token = tokens.find(t => t.collectionName === 'crms');
          return !token?.isActive;
        },
        onClick: ({ refresh }) => {
          showMigrationDocumentModal({
            onSuccess: () => {
              if (typeof refresh === 'function') refresh();
            },
          });
        },
      },
      'divider',
      dropdownParameters,
      'divider',
      {
        key: 'crmMigrationSettings',
        label: 'migrator',
        icon: <DatabaseOutlined />,
        onClick: ({ refresh }) => {
          showMigrationModal({
            onSuccess: () => {
              if (typeof refresh === 'function') refresh();
            },
          });
        },
      },
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default crmInitMenuButton;
